import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import withMessages from 'component-utilities/intl';
import displayName from 'component-lib/displayName';
import styles from './Pagination.scss';

function component({ extraClassName, getMessage, isDisabled, onClick }) {
    const nextClassName = isDisabled ? 'pagination-next-disabled' : 'pagination-next';
    const onNextClick = isDisabled ? void 0 : onClick;

    const classNames = cx({
        [styles[nextClassName]]: true,
        [extraClassName]: typeof extraClassName !== 'undefined',
    });

    return (
        <span
            role="presentation"
            data-action="next"
            className={classNames}
            onClick={onNextClick}
        >
            {getMessage('components.pagination.next')}
        </span>
    );
}

component.propTypes = {
    extraClassName: PropTypes.string,
    getMessage: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

component.defaultProps = {
    extraClassName: '',
    isDisabled: false,
};

const Next = withMessages(component);
Next.displayName = displayName('Pagination/Next');

export default Next;
